import { render, staticRenderFns } from "./SubscribePage.vue?vue&type=template&id=c8dc12ea&scoped=true&"
import script from "./SubscribePage.vue?vue&type=script&lang=js&"
export * from "./SubscribePage.vue?vue&type=script&lang=js&"
import style0 from "./SubscribePage.vue?vue&type=style&index=0&id=c8dc12ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8dc12ea",
  null
  
)

export default component.exports